exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrollToTop-iconButton{z-index:130;position:fixed;background-color:var(--generic-gray);color:var(--generic-black)}.scrollToTop-iconButton:hover{transition:0.3s;color:var(--generic-gray)}\n", ""]);

// exports
